import axios from '@/plugins/axios';

// 获取机构信息
export function geetest(geetestUrl) {
  return axios.get(geetestUrl, {
    params: {},
    timeout: 10000
  });
}

export function information(informationUrl, params) {
  return axios.post(informationUrl, params, { timeout: 10000 });
}
// 实名认证列表
export function listOrgRealname(params) {
  return axios.post('/departRealName/departList', params);
}
// 信息网查询的信息
export function getApplyInfo(applyId) {
  return axios.get('/departRealName/getById', {
    params: {
      applyId: applyId
    }
  });
}
// 用户填写的的信息
export function getOrgInfo(orgId) {
  return axios.get('/depart/getDepartmentById', {
    params: {
      departId: orgId
    }
  });
}
// 删除实名申请的信息
export function deleteRealnameById(applyId) {
  return axios.get('/departRealName/deleteById', {
    params: {
      applyId: applyId
    }
  });
}
// 实名审批
export function approvalApply(params) {
  return axios.post('/departRealName/approvalApply', params);
}
// 更新实名信息
export function editRealName(params) {
  return axios.post('/departRealName/editRealName', params);
}

// 查询机构实名认证付费信息
export function queryPayInfo(departId, orderType) {
  return axios.get('/departRealName/queryPayInfo', {
    params: {
      departId: departId,
      orderType: orderType
    }
  });
}
